import { watch } from 'vue'
import { watchGlobalVariable } from 'core/init/watch-global/index.js'
import { useUserAuthStore } from 'stores/user/auth'

export function useAntibot(runtimeContext) {
  const userAuthStore = useUserAuthStore()
  const platform = process.env.PLATFORM

  let antibotInitPromise = null

  function syncRuntimeContext() {
    if (!window.antibot) {
      return
    }

    const context = runtimeContext?.getContext?.()
    if (!context) {
      return
    }

    if (typeof window.antibot.setRuntimeMode === 'function') {
      window.antibot.setRuntimeMode(context.runtimeMode)
    }
    if (context.vendorDeviceId !== undefined && typeof window.antibot.setVendorDeviceId === 'function') {
      window.antibot.setVendorDeviceId(context.vendorDeviceId)
    }
    if (context.vendorAdId !== undefined && typeof window.antibot.setVendorAdId === 'function') {
      window.antibot.setVendorAdId(context.vendorAdId)
    }
  }

  function ensureAntibotReady() {
    if (!window.antibot || typeof window.antibot.init !== 'function') {
      return Promise.resolve()
    }

    syncRuntimeContext()

    if (!antibotInitPromise) {
      antibotInitPromise = window.antibot.init({ platform }).catch((e) => {
        antibotInitPromise = null
        throw e
      })
    }

    return antibotInitPromise
  }

  async function syncAntibotUser() {
    if (!window.antibot) {
      return
    }

    try {
      await ensureAntibotReady()

      const userId = userAuthStore.user?.id

      if (userId == null || typeof window.antibot.setUserId !== 'function') {
        return
      }

      window.antibot.setUserId(userId)
    } catch (e) {
      console.error(e)
    }
  }

  runtimeContext?.onChange?.(() => syncRuntimeContext())

  watch(
    () => userAuthStore.user?.id,
    () => {
      syncAntibotUser()
    },
    { immediate: true },
  )

  watchGlobalVariable('antibot').then(() => syncAntibotUser())
}
